import { render, staticRenderFns } from "./AddLomDocument.vue?vue&type=template&id=f425f70e"
import script from "./AddLomDocument.vue?vue&type=script&lang=js"
export * from "./AddLomDocument.vue?vue&type=script&lang=js"
import style0 from "./AddLomDocument.vue?vue&type=style&index=0&id=f425f70e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports